/**
 * @generated SignedSource<<de355d3514d5a713fa61ab627d0e6598>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpPersonalizedMixedGrid_viewer$data = {
  readonly homepageMixedGrid?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly item: {
            readonly __typename: string;
          };
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly user?: {
    readonly profile: {
      readonly firstName: string | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpPersonalizedMixedGridMobile_viewer" | "HpPersonalizedMixedGridResp_viewer">;
  readonly " $fragmentType": "HpPersonalizedMixedGrid_viewer";
};
export type HpPersonalizedMixedGrid_viewer$key = {
  readonly " $data"?: HpPersonalizedMixedGrid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpPersonalizedMixedGrid_viewer">;
};

import HpPersonalizedMixedGridPaginationQuery_graphql from './HpPersonalizedMixedGridPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "homepageMixedGrid",
  "items"
],
v1 = {
  "kind": "Variable",
  "name": "recommendationType",
  "variableName": "recommendationType"
},
v2 = [
  {
    "kind": "Variable",
    "name": "isPersonalizedContentAboveFoldTestVariant",
    "variableName": "isPersonalizedContentAboveFoldTestVariant"
  },
  {
    "kind": "Variable",
    "name": "mixedGridAfter",
    "variableName": "mixedGridAfter"
  },
  {
    "kind": "Variable",
    "name": "mixedGridFirst",
    "variableName": "mixedGridFirst"
  },
  (v1/*:: as any*/)
],
v3 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "abTestList"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "homepageId"
    },
    {
      "kind": "RootArgument",
      "name": "isMobile"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isPersonalizedContentAboveFoldTestVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "mixedGridAfter"
    },
    {
      "defaultValue": 8,
      "kind": "LocalArgument",
      "name": "mixedGridFirst"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationType"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "mixedGridFirst",
        "cursor": "mixedGridAfter",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "mixedGridFirst",
          "cursor": "mixedGridAfter"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": HpPersonalizedMixedGridPaginationQuery_graphql
    }
  },
  "name": "HpPersonalizedMixedGrid_viewer",
  "selections": [
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": (v2/*:: as any*/),
          "kind": "FragmentSpread",
          "name": "HpPersonalizedMixedGridMobile_viewer"
        }
      ]
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": (v2/*:: as any*/),
          "kind": "FragmentSpread",
          "name": "HpPersonalizedMixedGridResp_viewer"
        }
      ]
    },
    {
      "condition": "isPersonalizedContentAboveFoldTestVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "abTestList",
              "variableName": "abTestList"
            },
            {
              "kind": "Variable",
              "name": "homepageId",
              "variableName": "homepageId"
            },
            {
              "kind": "Variable",
              "name": "isMobile",
              "variableName": "isMobile"
            },
            (v1/*:: as any*/),
            (v3/*:: as any*/),
            {
              "kind": "Variable",
              "name": "userType",
              "variableName": "userType"
            }
          ],
          "concreteType": "HomepageMixedGrid",
          "kind": "LinkedField",
          "name": "homepageMixedGrid",
          "plural": false,
          "selections": [
            {
              "alias": "items",
              "args": null,
              "concreteType": "HomepageMixedGridItemsConnection",
              "kind": "LinkedField",
              "name": "__HpPersonalizedMixedGrid_items_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "HomepageMixedGridItemsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HomepageMixedGridItemEntry",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "item",
                          "plural": false,
                          "selections": [
                            (v4/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        (v4/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v3/*:: as any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "e76bf295fbfa747c9c9aeb5b03004509";

export default node;
